export function stripFencedCode(md: string): string {
  if (!md) return '';
  return String(md).replace(/```[\s\S]*?```/g, '');
}
